import CircularProgress from "@mui/material/CircularProgress";
import { InputField } from "components/InputField";
import React from "react";

const MemberEventDrawerUpdates = ({
  newUpdateField,
  setUpdateValue,
  errorMessage,
  setErrorMessage,
  createFollowupLoading,
  handleCloseNewUpdate,
  handleSubmitNewUpdate,
  openNewTaskDrawer,
  handleAddNewUpdate,
}) => {
  return (
    <div className="d-flex flex-column flex-grow-1 justify-content-end ">
      {newUpdateField == true ? (
        <div className="updateField">
          <p className="newupdate-p">New Update</p>
          <InputField
            handleChange={(e) => {
              setErrorMessage("");
              setUpdateValue(e?.target?.value);
            }}
            {...{
              name: "subject",
              placeholder: "Type Update here",
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSubmitNewUpdate();
              }
            }}
          />
          {errorMessage && <p className="text-danger mt-2">{errorMessage}</p>}
          <div className="w-100 d-flex justify-content-end">
            <div className="updatefield-btns">
              <button className="close" onClick={handleCloseNewUpdate}>
                Cancel
              </button>
              <button
                type="button"
                className="submit"
                disabled={createFollowupLoading}
                onClick={handleSubmitNewUpdate}
              >
                {createFollowupLoading ? (
                  <CircularProgress size={14} />
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="d-flex justify-content-end mt-5 addbtns">
        <a className="add font-weight-bold mr-5" onClick={openNewTaskDrawer}>
          + New Task
        </a>
        <a className="add font-weight-bold" onClick={handleAddNewUpdate}>
          + New Update
        </a>
      </div>
    </div>
  );
};

export default MemberEventDrawerUpdates;
